import PreferencesApp from './PreferencesApp'

export default PreferencesApp
